import Vue from 'vue';
import App from './App.vue';
import router from '../../router';
import vuetify from '../../plugins/vuetify';
import Auth from '../../auth';

Vue.config.productionTip = false;

Vue.use(Auth);

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app');
